import AttendanceAdapter from './base';

export default class NzMoeDaysByLearner extends AttendanceAdapter {
  modelNamePlural = 'nzMoeDaysByLearners';
}
